











import { defineComponent, watch, computed, toRefs } from '@vue/composition-api';
import { PropType } from 'vue';
import { VideoDownloadStatus, AdgroupFormData, CampaignFormData, AdgroupConfig } from '@tt4b/ttam-enums';
import placementVideoDownload from './index';

const name = 'ttam-placement-video-download-compose';

export default defineComponent({
  name,
  components: {
    TtamPlacementVideoDownloadSwitch: placementVideoDownload.TtamPlacementVideoDownloadSwitch,
  },
  props: {
    campaignData: {
      type: Object as PropType<CampaignFormData>,
      required: true,
      default: () => ({}),
    },
    adgroupData: {
      type: Object as PropType<AdgroupFormData>,
      required: true,
      default: () => ({}),
    },
    adgroupConfig: {
      type: Object as PropType<AdgroupConfig>,
      required: true,
      default: () => ({}),
    },
  },
  setup(props, { emit }) {
    const { adgroupData, campaignData, adgroupConfig } = toRefs(props);

    const { disabled: videoDownloadDisabled, isOnlySelectJapan } = placementVideoDownload.useSwitchPropsDisabled({
      adgroupData,
      adgroupConfig,
    });

    const _videoDownloadStatus = computed({
      get: () => {
        if (isOnlySelectJapan.value) {
          // 定向地区仅是日本时，后端会强制设置成不支持下载，前端只需要处理一下显示就行
          return VideoDownloadStatus.DISABLE;
        }
        return props.adgroupData.adDownloadStatus;
      },
      set: v => emit('change', v),
    });

    const { tips: videoDownloadTips } = placementVideoDownload.useSwitchHintPropsTips({
      adgroupData,
    });

    const { visible } = placementVideoDownload.useSwitchPropsVisible({
      adgroupData,
      campaignData,
    });

    watch(
      visible,
      newVal => {
        if (!newVal) {
          _videoDownloadStatus.value = VideoDownloadStatus.ENABLE;
        }
      },
      {
        immediate: true,
      },
    );

    return {
      videoDownloadTips,
      _videoDownloadStatus,
      videoDownloadDisabled,
      visible,
      name,
    };
  },
});
